import React, { useState } from 'react'
import { FiSearch } from 'react-icons/fi'
import PropTypes from 'prop-types'
import { cn } from 'src/lib/utils'
import { IoMdClose } from 'react-icons/io'

const CustomSearchField = ({ value, onValueChange, searchData, setSelectedData , className, setSearch, disabled }) => {
    
    const handleSelectData = (data) => {
        if (setSelectedData) {
            setSelectedData(data);
        }
    }

    const handleInputChange = (e) => {
        const trimmedValue = e?.target?.value.toLowerCase().replace(/^\s+/, '');
        onValueChange(trimmedValue);
    }

    const handleClearSearch = () => {
        setSearch('')
        onValueChange('');
    }

    return (
        <div className={cn("flex items-center space-x-2", className)}>
            <div className={cn("relative flex items-stretch", className)}>
                <input
                    type="text"
                    placeholder="Search"
                    value={value}
                    disabled={disabled}
                    onChange={handleInputChange}
                    className={cn("grc-search-input text-b4 h-full min-h-[36px] !p-3", 'w-[100%]')}/>
                <div type="button" className="grc-search-icon cursor-pointer !bg-[#fff]">
                    {value?.length > 0 ? <IoMdClose onClick={handleClearSearch} /> : <FiSearch/>}
                </div>
                {searchData && searchData.length > 0 && (
                    <div className="block w-full bg-white border border-gray-300 rounded-md py-2 px-1 leading-tight focus:outline-none focus:border-green-500">
                        {searchData.map((obj, index) => (
                            <div key={index} onClick={() => handleSelectData(obj)}>
                                {obj.name}
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </div>
    )
}
CustomSearchField.propTypes = {
    value: PropTypes.string,
    onValueChange: PropTypes.func,
    searchData: PropTypes.array,
    setSelectedData: PropTypes.func,
    className: PropTypes.any
}

export default CustomSearchField
